import { ClassNames, css } from "@emotion/react";
import { Component } from "react";
import { connect } from "react-redux";

import { ActionModal, Button, Loader, ModalPortal } from "@livechat/design-system";
import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon/Icon";
import { trackScheduledReportAction } from "helpers/analytics-reports";
import { ReportsViewActions, getIsReportDeleting } from "store/views/reports";
import { withVar } from "themes/helpers";

import { iconStyles } from "../styled/report-form";

const buttonStyles = {
  margin: "0 4px",
  width: "150px",
};

const headingStyles = css`
  h2 {
    max-width: 300px;
  }
`;

interface IStateProps {
  isDeleting: boolean;
}

interface IDispatchProps {
  deleteScheduledReport(id: string): void;
}

interface IState {
  shouldClose: boolean;
  isDeletingProcessing: boolean;
}

interface IProps extends IStateProps, IDispatchProps {
  id: string;
  modalHeader: string;
  onClose: () => void;
}

class DeleteScheduledReportModal extends Component<IProps, IState> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);

    this.state = {
      shouldClose: false,
      isDeletingProcessing: false,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    return {
      shouldClose: nextProps.isDeleting === false && prevState.isDeletingProcessing,
    };
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onDelete = () => {
    this.props.deleteScheduledReport(this.props.id);
    trackScheduledReportAction("delete confirmed");
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  onCancel = () => {
    this.props.onClose();
    trackScheduledReportAction("delete cancelled");
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { modalHeader, isDeleting, onClose } = this.props;
    const { shouldClose, isDeletingProcessing } = this.state;

    if (isDeleting && !isDeletingProcessing) {
      this.setState({ isDeletingProcessing: true });
    }

    if (shouldClose) {
      onClose();
    }

    return (
      // @ts-expect-error TS(2559)
      <ModalPortal>
        <ActionModal
          onClose={this.onCancel}
          heading={modalHeader}
          css={headingStyles}
          icon={
            <Icon
              name={IconsEnum.ModalInfo}
              width="54px"
              height="54px"
              fill={withVar(DesignToken.ContentBasicSecondary)}
            />
          }
          actions={
            <>
              <Button style={buttonStyles} size="large" onClick={this.onCancel} disabled={isDeleting}>
                Cancel
              </Button>
              <Button
                style={buttonStyles}
                size="large"
                onClick={this.onDelete}
                kind="destructive"
                disabled={isDeleting}
              >
                {isDeleting ? (
                  <ClassNames>
                    {({ css: innerCss }) => (
                      <Loader
                        size="small"
                        css={iconStyles}
                        label="Deleting..."
                        labelClassName={innerCss`
                          color: ${withVar(DesignToken.ContentInvertPrimary)};
                        `}
                        primaryColor={withVar(DesignToken.ActionPrimaryDefault)}
                      />
                    )}
                  </ClassNames>
                ) : (
                  "Delete report"
                )}
              </Button>
            </>
          }
        >
          <div>You won&apos;t receive this report anymore.</div>
        </ActionModal>
      </ModalPortal>
    );
  }
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any): IStateProps => ({
  isDeleting: getIsReportDeleting(state),
});

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
  deleteScheduledReport: id => dispatch(ReportsViewActions.deleteScheduledReport({ id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteScheduledReportModal);
